module.exports = __webpack_public_path__ + "img/introduce_img.434665ea.png";